import _ from 'lodash';
import { prepareBaseAutoSaveData, resolveAutoSaveSanitizeOptions } from './shared';
import { createJsonConfiguredAutoSaveAdapter } from './jsonAutoSave';

const normalizeBusinessLiteData = (data, autoSaveConfig) => {
    const prepared = prepareBaseAutoSaveData(data, resolveAutoSaveSanitizeOptions(autoSaveConfig));

    if (!prepared || typeof prepared !== 'object') {
        return prepared;
    }

    if (Array.isArray(prepared.individuals) && prepared.individuals.length > 0) {
        prepared.individuals = prepared.individuals.map((individual, index) => {
            if (!_.isPlainObject(individual)) {
                return individual;
            }

            const nextIndividual = _.cloneDeep(individual);
            nextIndividual.isControlPerson = false;
            if (index === 0) {
                nextIndividual.isPrimaryUser = true;
                if (!nextIndividual.email && prepared.email) {
                    nextIndividual.email = prepared.email;
                }
                if (!nextIndividual.accessType) {
                    nextIndividual.accessType = 'NoGroup';
                }
                nextIndividual.isAuthorizedUser = true;
            }
            return nextIndividual;
        });
    }

    if (prepared.interestedInPrime) {
        prepared.talkToSales = true;
    }

    if (!prepared.hasEntity) {
        prepared.entities = [];
    }

    if (!prepared.landlinePhone) {
        delete prepared.landlineCountryCode;
    }

    if (!prepared.mobilePhone) {
        delete prepared.mobileCountryCode;
    }

    return prepared;
};

export const createBusinessLiteAutoSaveAdapter = (fieldDefinitions = {}, autoSaveConfig = null) => createJsonConfiguredAutoSaveAdapter({
    autoSaveConfig: _.cloneDeep(autoSaveConfig || {}),
    fieldDefinitions: _.cloneDeep(fieldDefinitions || {}),
    prepareData(data) {
        return normalizeBusinessLiteData(data, autoSaveConfig);
    },
});
